
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/top/[categoryFeatureName]",
      function () {
        return require("private-next-pages/top/[categoryFeatureName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/top/[categoryFeatureName]"])
      });
    }
  